import { defineStore } from 'pinia'
import { reactive } from 'vue'

export interface IRedirectStoreState {
	redirectTo: string
}

export interface IRedirectStore {
	readonly state: {
		redirectTo: string
	}
	setRedirectTo(redirectTo: string): void
	getRedirectTo(): string
	clearRedirectTo(): void
}

export const useRedirectStore = defineStore('redirectStore', (): IRedirectStore => {
	const _state = reactive<IRedirectStoreState>({
		redirectTo: '',
	})

	const setRedirectTo = (redirectTo: string) => {
		_state.redirectTo = redirectTo
	}

	const clearRedirectTo = () => {
		_state.redirectTo = ''
	}

	const getRedirectTo = () => {
		const redirectTo = _state.redirectTo
		clearRedirectTo()
		return redirectTo
	}

	return {
		state: _state,
		setRedirectTo,
		getRedirectTo,
		clearRedirectTo,
	}
})
